import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IThunkApi } from 'shared/types/redux';
import type { TNaturalPersonUpdateRequest } from 'shared/repositories/dailyrent/v1/natural-person/update';
import {
  TUpdateNaturalPersonError,
  updateNaturalPersonData,
} from 'shared/services/onlineBookingProfile/updateNaturalPersonData';

export const updateNaturalPerson = createAsyncThunk<
  void,
  TNaturalPersonUpdateRequest,
  IThunkApi & { rejectValue: TUpdateNaturalPersonError }
>('hostProfile/updateNaturalPerson', async (params, thunkApi) => {
  const { extra: context } = thunkApi;

  const result = await updateNaturalPersonData({
    httpApi: context.httpApi,
    logger: context.logger,
    parameters: params,
  });

  if (!result.ok) {
    return thunkApi.rejectWithValue(result.error);
  }

  return undefined;
});
